import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import { sendOrderNotification } from '@/data/api/request/orderDetailsRequest';
import { useMutation } from '@tanstack/react-query';

export function useSendOrderNotification() {
  const { showSnackError, showSnackSuccess } = useSnackbarContext();

  const { isPending, mutate } = useMutation({
    mutationFn: sendOrderNotification,
    onError: () => showSnackError('Error al enviar la orden por Whatsapp'),
    onSuccess: () => showSnackSuccess('Orden enviada con exito'),
  });

  return {
    sendOrderNotification: mutate,
    isSendingOrderNotification: isPending,
  };
}
